import { PUBLIC_CORE_APP_URL_ENV, PUBLIC_SITENAME } from 'tools/environments';

export const NEWS_IMAGE_FALLBACK = PUBLIC_SITENAME
	? `${PUBLIC_CORE_APP_URL_ENV}/assets/images/club/${PUBLIC_SITENAME}/crest/crest-plain.svg`
	: null;
